<template>
  <tr>
    <td>
      <router-link :to="`/products/${product.accumulated_id}`">
        {{ product.name }}
        <span v-if="viewType !== 'product' && product.product_instance.product.is_variation_of">({{ product.product_instance.product.stringRepShort.join(' | ') }})</span>
      </router-link>
    </td>
    <td>
      <a href="#"
        v-for="(productCategory, index) in product.product_instance.product.product_categories" :key="productCategory.id"
        @click.prevent="$emit('filterProductCategory', productCategory)"
      >
        {{ productCategory.name }}<span v-if="index !== product.product_instance.product.product_categories.length - 1">, </span>
      </a>
    </td>
    <td class="text-right" v-if="hideableColumns.showEkPrice">
      {{ product.einkaufspreis | priceFromCentEuro }}
    </td>
    <td class="text-right">{{ product.product_instance.product.price | priceFromCentEuro }}</td>
    <td class="text-right">
      {{ product.sum_quantity }}
    </td>
    <td class="text-right">
      {{ product.inventur_quantity }}
    </td>
    <td class="text-right">
      {{ product.warnschwelle }}
    </td>
    <td class="text-right">
      {{ product.lager_soll_menge }}
    </td>
    <td class="text-center" v-if="hideableColumns.showLager">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openWarehouses', product)">
        <i class="fas fa-warehouse"></i>
      </a>
    </td>
    <td class="text-center" v-if="hideableColumns.showLieferanten">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openSuppliers', { product: product.product_instance.product, productSuppliersSorted })">
        <i class="fas fa-truck"></i>
      </a>
    </td>
  </tr>
</template>

<script>
import { groupNewestSuppliers } from 'src/util/helpers'

export default {
  props: ['product', 'onlyShowAction', 'hideableColumns', 'viewType'],
  computed: {
    productSuppliersSorted () {
      return groupNewestSuppliers(this.product.product_instance.product.suppliers)
    }
  }
}
</script>

<style>
</style>
